import React from "react";

const LoadingPage = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="text-center">
        {/* CSS Spinner */}
        <div className="spinner w-16 h-16 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin mx-auto"></div>
        <p className="mt-4 text-lg text-gray-600">Loading, please wait...</p>
      </div>
    </div>
  );
};

export default LoadingPage;
